import { render, staticRenderFns } from "./InternalOrderSelector.vue?vue&type=template&id=fcfa3518&scoped=true"
import script from "./InternalOrderSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./InternalOrderSelector.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InternalOrderSelector.vue?vue&type=style&index=0&id=fcfa3518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcfa3518",
  null
  
)

export default component.exports